import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { mapAsBody } from '../app/shared/util/request-util';

@Injectable({ providedIn: 'root' })
export class BaryDataSearchService {
  private ressource = API_ENDPOINTS.SIRENE_URL;

  constructor(public apiProviderService: ApiProviderService) {}

  findBySiret(siret: string): Observable<any> {
    const param = new HttpParams().set('siret', siret);
    return this.apiProviderService.publicGet<any>(this.ressource, param).pipe(mapAsBody);
  }
}
